import {
  AlignSelfType,
  BorderType,
  HoverType,
  PaddingType,
} from 'common/types/styleTypes'
import {
  backgroundCss,
  borderCss,
  boxShadowCss,
  FontProps,
  fontCss,
  hoverCss,
  hoverTransformCss,
  hoverTransitionCss,
  lineHeightCss,
  mobileBackgroundCss,
  mobileBorderCss,
  mobileBoxShadowCss,
  mobileFontCss,
  mobileHoverCss,
  mobileHoverTransformCss,
  mobileHoverTransitionCss,
  mobileLineHeightCss,
  mobilePaddingsCss,
  paddingsCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

interface ButtonUiProps extends FontProps {
  background?: string
  mobileBackground?: string
  color?: string
  mobileColor?: string
  padding?: Partial<PaddingType>
  mobilePadding?: Partial<PaddingType>
  width?: 'auto' | '100%'
  mobileWidth?: 'auto' | '100%'
  border?: Partial<BorderType>
  mobileBorder?: Partial<BorderType>
  alignSelf?: AlignSelfType
  mobileAlignSelf?: AlignSelfType
  boxShadow?: string
  mobileBoxShadow?: string
  lineHeight?: number
  mobileLineHeight?: number
  hover?: HoverType
  mobileHover?: HoverType
}

const ButtonUi = styled.button<ButtonUiProps>`
  width: ${p => p.width || 'auto'};
  align-self: ${p => p.alignSelf || 'center'};
  opacity: ${p => (p.disabled ? '0.7' : '1')};
  cursor: pointer;
  border: none;
  ${backgroundCss}
  ${paddingsCss}
  ${fontCss}
  ${borderCss}
  ${boxShadowCss}
  ${lineHeightCss}
  ${hoverCss}
  ${hoverTransformCss}
  ${hoverTransitionCss}

// wrapped in a condition so that there is no error in <EntityPreview /> in the sidebar
  ${p =>
    p?.theme?.phone &&
    css`
    ${p.theme.phone} {
      width: ${p.mobileWidth || '100%'};
      align-self: ${p.mobileAlignSelf || 'center'};
      opacity: ${p.disabled ? '0.7' : '1'};
      ${mobileBackgroundCss}
      ${mobilePaddingsCss}
      ${mobileFontCss}
      ${mobileBorderCss}
      ${mobileBoxShadowCss}
      ${mobileLineHeightCss}
      ${mobileHoverCss}
      ${mobileHoverTransformCss}
      ${mobileHoverTransitionCss}
    }
  `}

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileHoverCss}
      ${mobileHoverTransformCss}
      ${mobileHoverTransitionCss}
      ${mobileBackgroundCss}
      ${mobilePaddingsCss}
      ${mobileBorderCss}
      ${mobileFontCss}
      ${mobileBoxShadowCss}
      ${mobileLineHeightCss}
      width: ${p.mobileWidth || '100%'};
      align-self: ${p.mobileAlignSelf || 'center'};
    `}
`

export default ButtonUi
